module.exports = __webpack_public_path__ + "static/img/18.c5e75e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/18.png
// module id = x0MF
// module chunks = 0